import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingStateService {
    private isLoadingSubject = new BehaviorSubject<boolean>(false);
    private pendingRequests = new Map<string, boolean>();
    public setIsLoading(isLoading: boolean, url: string) {
        if (!url) {
            throw new Error('The request URL must be provided to the LoadingService.setLoading function');
        }
        if (isLoading === true) {
            this.pendingRequests.set(url, isLoading);
            this.isLoadingSubject.next(true);
        } else if (isLoading === false && this.pendingRequests.has(url)) {
            this.pendingRequests.delete(url);
        }
        if (this.pendingRequests.size === 0) {
            this.isLoadingSubject.next(false);
        }
    }
    public getIsLoading() {
        return this.isLoadingSubject.asObservable();
    }
}
